export const REDUCER_NAME = "playerSeasons";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_PLAYERSEASONS = `${REDUCER_NAME}/SET_PLAYERSEASONS`;
export const RESET_PLAYERSEASONS = `${REDUCER_NAME}/RESET_PLAYERSEASONS`;
